import { render } from "./AdminAddProduct.vue?vue&type=template&id=004f2e45&scoped=true"
import script from "./AdminAddProduct.vue?vue&type=script&lang=js"
export * from "./AdminAddProduct.vue?vue&type=script&lang=js"

import "./AdminAddProduct.vue?vue&type=style&index=0&id=004f2e45&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004f2e45"]])

export default __exports__